function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffa800"
    },
    fillRule: "evenodd",
    d: "M15 0C6.716 0 0 6.715 0 14.999 0 23.285 6.716 30 15 30c8.284 0 15.001-6.715 15.001-15.001C30.001 6.715 23.284 0 15 0zm6.18 20.357l-.822.827-5.36-5.359-5.356 5.359-.823-.827 5.356-5.356-5.356-5.358.823-.825 5.356 5.356 5.36-5.356.822.825-5.356 5.358 5.356 5.356z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRemove);
export default __webpack_public_path__ + "static/media/ico-remove.d1c1a48f155097de068bc49c0ef2db4b.svg";
export { ForwardRef as ReactComponent };